module.exports = __webpack_public_path__ + "static/media/04.d15a24ba.jpg";